import { AxiosError, AxiosResponse } from "axios";
import axiosClient from "../../common/axios/axiosConfig";
import { ITelemedicineData } from "../../common/interfaces/ITelemedicineData";

interface IError {
  error: string;
  message: string;
  statusCode: number;
}

export const authenticate = (
  telemedicineToken: string,
  setMessage: (message: string) => void
): Promise<void | AxiosResponse<ITelemedicineData>> => {
  return axiosClient
    .get(`/room`, {
      headers: {
        Authorization: `Bearer ${telemedicineToken}`
      }
    })
    .catch((error: AxiosError<{ message: string }>) => {
      if (error.response) {
        const status = error.response.status;
        const message = error.response.data?.message ?? "Erro desconhecido.";

        switch (status) {
          case 403:
            setMessage(message);
            break;
          default:
            setMessage(
              "Ocorreu um erro ao validar seu usuário, recarregue a página e tente novamente."
            );
            break;
        }
      }
    });
};

